import { useState } from "react";

import { AsyncState, Button, Link } from "@shapr3d/frontend-lib";

import { supportEmail } from "../../config";
import useNavigation from "../../hooks/navigation";
import Heading from "../Heading/Heading";

import style from "./ZendeskEmailVerify.module.css";

export interface ZendeskEmailVerifyProps {
  onResendClick: () => void;
}

const ZendeskEmailVerify = (props: ZendeskEmailVerifyProps) => {
  const navigation = useNavigation();
  const [verifyResendState, setVerifyResendState] = useState(AsyncState.Initial);

  const onResendClick = async () => {
    setVerifyResendState(AsyncState.Pending);
    try {
      await props.onResendClick();
      setVerifyResendState(AsyncState.Done);
    } catch (err) {
      setVerifyResendState(AsyncState.Error);
    }
  };

  const content = (() => {
    switch (verifyResendState) {
      case AsyncState.Initial:
      case AsyncState.Pending:
        return (
          <Button
            onClick={onResendClick}
            className={style.button}
            disabled={verifyResendState === AsyncState.Pending}
          >
            Resend email
          </Button>
        );
      case AsyncState.Done:
        return (
          <div className={style.text}>A new verification email has been sent to your address.</div>
        );
      case AsyncState.Error:
        return (
          <div className={style.text}>
            Something went wrong. You can contact the support team at{" "}
            <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link>.
          </div>
        );
    }
  })();

  return (
    <div className={style.container}>
      <div className={style.content}>
        <Heading type="h1">Verify your email</Heading>
        <div className={style.text}>
          To access our support portal, first you&apos;ll need to verify your email address. Please
          check your inbox or request a new verification email here:
        </div>
        {content}
        <Button
          onClick={() => navigation.goToProfile()}
          variant="grayscale"
          className={"back-to-account"}
        >
          Back to account
        </Button>
      </div>
    </div>
  );
};

export default ZendeskEmailVerify;
